import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
const VARIANTS = {
    primary: "bg-accent text-bg hover:bg-accent-dark",
    secondary: "bg-surface text-ink border border-line hover:border-ink-soft",
    ghost: "bg-transparent text-accent hover:bg-line/40",
    // Sama ramka w zieleni; hover wypełnia. Akcja drugoplanowa, która nadal
    // wygląda na akcję - nawigacja i tańsze pakiety w cenniku.
    outline: "bg-transparent text-accent border border-accent hover:bg-accent hover:text-bg",
};
const SIZES = {
    sm: "px-4.5 py-2.5 text-sm",
    md: "px-5 py-3 text-md",
    lg: "px-7 py-4 text-md",
};
/**
 * Same klasy przycisku, bez elementu.
 *
 * Część akcji to w rzeczywistości odnośniki (`Link` do `/kup`), a przycisk
 * w środku odnośnika to dwa zagnieżdżone elementy interaktywne. Zamiast
 * kopiować listę klas do arkusza strony, wystawiamy ją tutaj.
 */
export function buttonClassName({ variant = "secondary", size = "md", fullWidth = false, className, } = {}) {
    return clsx("inline-flex items-center justify-center gap-2 rounded-control", "font-ui font-medium", 
    // Animujemy tylko kolor i przezroczystość - żadnych przeliczeń układu.
    "transition-colors duration-200", "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent", "disabled:cursor-not-allowed disabled:opacity-60", VARIANTS[variant], SIZES[size], fullWidth && "w-full", className);
}
export function Button({ variant = "secondary", size = "md", fullWidth = false, className, type = "button", ...props }) {
    return (_jsx("button", { type: type, className: buttonClassName({ variant, size, fullWidth, className }), ...props }));
}
